export const iconFontAwesomeHandsHandshakeAngle = (
	<i className="fa-solid fa-handshake-angle"></i>
);
